import PropTypes from 'prop-types'
import React from 'react'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'

export const AdLimit = ({ packages }) => {
  const text = config.registrationForm.package.adLimit
  return (
    <tr>
      
      <Trans
        i18nKey='common:packages_adLimit_text'
        components={{
          td: <td />,
          strong: <strong />
        }}
        defaultTrans='<td>Broj vidljivih <strong>aktivnih</strong> oglasa na sajtu</td>'
      />
      {
        packages.map(item => <td key={item.id}>{Number(item.adLimit)}</td>)
      }
    </tr>
  )
}

AdLimit.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    adLimit: PropTypes.number
  })).isRequired
}

AdLimit.defaultProps = {
  packages: []
}
